import React, { useEffect } from "react";
import StudentEnrollmentForm from "./StudentEnrollmentForm";

export default function PrintEnrollment() {
  useEffect(() => {
    const t = setTimeout(() => {
      try { window.print(); } catch (e) { /* ignore */ }
    }, 800);
    return () => clearTimeout(t);
  }, []);
  return (
    <div className="container-fluid">
      <StudentEnrollmentForm />
    </div>
  );
}
